import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateCurvaAbcVenda } from './can-activate-curva-abc-venda';
import { CurvaAbcVendaComponent } from './curva-abc-venda.component';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateCurvaAbcVenda],
                children: [
                    {path: '', component: CurvaAbcVendaComponent},
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateCurvaAbcVenda
    ]
})
export class CurvaAbcVendaRoutingModule { }
